import { FC } from 'react';
import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { NeauviaItem } from 'src/models/directus';
import { media } from 'src/styles/designs';
import { useRelatedItemsListQuery } from 'src/modules/materials/hooks/useRelatedItemsListQuery';
import { Thumbnail } from 'src/modules/materials/components/Thumbnail';
import { AnimatePresence, motion } from 'framer-motion';
import { makeTransition } from 'src/utils/motion/transitions';

export interface MaterialPageRelatedItemsProps {
  item: NeauviaItem;
}

const Container = styled(motion.div)`
  ${media.w.lessThan.desktop} {
    margin: 24px 0;
    border-top: 1px solid ${({ theme }) => theme.skeleton.base};
  }
  ${media.w.greaterThanOrEqual.desktop} {
    min-height: 300px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Heading = styled.h3`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.palette.accent};

  margin: 24px 0 16px;
  ${media.w.greaterThanOrEqual.desktop} {
    margin: 0 0 24px;
  }
`;

export const MaterialPageRelatedItems: FC<MaterialPageRelatedItemsProps> = ({
  item,
}) => {
  const { _ } = useTranslate();
  const { data: relatedItems } = useRelatedItemsListQuery(item);

  return (
    <AnimatePresence>
      <Container>
        {relatedItems && relatedItems.length > 0 && (
          <motion.div {...makeTransition({ fade: true })}>
            <Heading>{_('You might like')}</Heading>
            <ContentContainer>
              {relatedItems.slice(0, 1).map((item) => (
                <Thumbnail key={item.id} item={item} showTypeLabel />
              ))}
            </ContentContainer>
          </motion.div>
        )}
      </Container>
    </AnimatePresence>
  );
};
